export default "__VITE_ASSET__Czgsvk5T__"